import { FC, PropsWithChildren } from 'react';

import { useLinkComponent } from '@eneco/link';
import { ButtonLink, Card, Heading, Stack, TextLink } from '@eneco/sparky';

import RichText from '../../RichText/RichText';

export interface EndStepCardProps {
  title: string;
  content: string;
  buttonHref?: string;
  buttonText?: string;
  textLinkHref?: string;
  textLinkAction?: () => void;
  textLinkText?: string;
}

export const EndStepCard: FC<PropsWithChildren<EndStepCardProps>> = ({
  title,
  content,
  buttonHref,
  buttonText,
  textLinkHref,
  textLinkAction,
  textLinkText,
  children,
}) => {
  const Link = useLinkComponent();

  return (
    <Card>
      <Card.Content>
        <Stack gap="8">
          <Stack gap="4">
            {title && (
              <Heading as="h1" size="L">
                {title}
              </Heading>
            )}
            {content && (
              <Stack gap="5">
                <RichText html={content} />
              </Stack>
            )}
          </Stack>

          {children}

          {buttonHref && buttonText && (
            <Stack.Item>
              <Link href={buttonHref} linkType="external">
                <ButtonLink>{buttonText}</ButtonLink>
              </Link>
            </Stack.Item>
          )}

          {textLinkText && (
            <Stack.Item>
              {textLinkHref && (
                <Link href={textLinkHref} linkType="external">
                  <TextLink emphasis="high">{textLinkText}</TextLink>
                </Link>
              )}
              {textLinkAction && (
                <TextLink emphasis="high" onClick={textLinkAction}>
                  {textLinkText}
                </TextLink>
              )}
            </Stack.Item>
          )}
        </Stack>
      </Card.Content>
    </Card>
  );
};
